import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IntlTelInput from 'intl-tel-input/react';

const styles = {
  '@global': {
    '.gid-phone-input .iti': {
      width: '100%',
      display: 'block',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderRadius: '10px',
      boxSizing: 'border-box',
      transition: 'border-color 200ms cubic-bezier(0.0, 0, 0.2, 1)',
    },
    '.gid-phone-input .iti:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
    '.gid-phone-input .iti:focus-within': {
      border: '2px solid #0076bb',
    },
    '.gid-phone-input .iti input[type="tel"]': {
      width: '100%',
      height: '56px',
      border: 'none',
      outline: 'none',
      fontFamily: '"Karla", sans-serif',
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 0.87)',
      background: 'transparent',
      boxSizing: 'border-box',
    },
    '.gid-phone-input .iti input[type="tel"]::placeholder': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '.gid-phone-input--error .iti': {
      borderColor: '#e57373',
    },
    '.gid-phone-input--error .iti:focus-within': {
      border: '2px solid #e57373',
    },
    '.gid-phone-input__helper-text': {
      fontFamily: '"Karla", sans-serif',
      fontSize: '0.75rem',
      margin: '3px 14px 0',
      color: '#e57373',
    },
    '.iti__dropdown-content': {
      zIndex: '9999 !important',
    },
  },
};

class GnPhoneInput extends React.Component {

  render() {
    const {
      error = null,
      onChangeNumber = function () { },
      onChangeValidity = function () { },
      onlyCountries = [],
      placeholder = 'Phone Number',
      style = {},
      value,
    } = this.props;

    const containerClass = [
      'gid-phone-input',
      error ? 'gid-phone-input--error' : '',
    ].filter(Boolean).join(' ');

    return (
      <div style={style}>
        <div className={containerClass}>
          <IntlTelInput
            initialValue={value}
            onChangeNumber={onChangeNumber}
            onChangeValidity={onChangeValidity}
            inputProps={{
              id: 'smsPhoneNumber',
              placeholder,
              enterkeyhint: 'done',
              onKeyDown: (e) => {
                // Android's Go/Enter/Check key does nothing by default; blur to dismiss the keyboard like iOS
                if (e.key === 'Enter' || e.keyCode === 13) {
                  e.preventDefault();
                  e.target.blur();
                }
              },
            }}
            initOptions={{
              useFullscreenPopup: false,
              initialCountry: 'us',
              onlyCountries: onlyCountries.length ? onlyCountries : undefined,
              loadUtils: () => import('intl-tel-input/build/js/utils.js'),
            }}
          />
        </div>
        {error && (
          <p className="gid-phone-input__helper-text">{error}</p>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(GnPhoneInput);
